import {
  FORM_INPUT_CHANGE,
  GET_PATIENTS_SUCCESS,
  GET_PATIENT_SUCCESS,
  GET_PERFORMAONE_SUCCESS,
  GET_SCANS_SUCCESS,
  GET_DISORDER_ANS_TREATMENT_SUCCESS,
  GET_XRAY_SUCCESS,
  GET_CLINICAL_FEATURE_SUCCESS,
  FORM_INPUT_CHANGE_MULTIPLE,
  GET_DEXA_SUCCESS,
  GET_INVESTIGATION_SUCCESS,
  GET_DEXA1_SUCCESS,
  GET_DEXA3_SUCCESS,
  GET_HRPQCT_SUCCESS,
  RESET_XRAY_STATE,
  RESET_SCAN_STATE,
  RESET_DEXA1_STATE,
  RESET_DEXA3_STATE,
  RESET_DISORDER_ANS_TREATMENT_STATE,
  RESET_INVESTIGATION_STATE,
  RESET_PATIENT_STATE,
  RESET_CLINICAL_FEATURE_STATE,
  RESET_DEXA_STATE,
  RESET_GET_PERFORMAONE_STATE,
} from "../Utils/Constants";

const patientDetails = {
  name: "",
  age: 0,
  sex: "M",
  crno: "",
  admissionno: "",
  ecno: "",
  DOA: new Date("2000-01-01T01:00:00"),
  DOS: new Date("2000-01-01T01:00:00"),
  DOD: new Date("2000-01-01T01:00:00"),
  address: "",
  telephone: "",
  mobile: "",
  email: "",
  aadharCard: "",
  parents: "",
  grandparents: "",
  consent: "N",
  DOR: new Date(),
};

export const patientDetailsFormReducer = (state = patientDetails, action) => {
  if (action.type === FORM_INPUT_CHANGE) {
    return {
      ...state,
      [action.payload.name]: action.payload.value,
    };
  }

  return state;
};

const patientDetailsEdit = {
  name: "",
  age: 0,
  sex: "M",
  crno: "",
  admissionno: "",
  ecno: "",
  DOA: new Date("2000-01-01T01:00:00"),
  DOS: new Date("2000-01-01T01:00:00"),
  DOD: new Date("2000-01-01T01:00:00"),
  address: "",
  telephone: "",
  mobile: "",
  email: "",
  aadharCard: "",
  parents: "",
  grandparents: "",
  consent: "N",
  DOR: "",
};

export const getPatientDetailsReducer = (
  state = patientDetailsEdit,
  action
) => {
  if (action.type === FORM_INPUT_CHANGE) {
    return {
      ...state,
      [action.payload.name]: action.payload.value,
    };
  }
  if (action.type === GET_PATIENT_SUCCESS) {
    return {
      ...state,
      ...action.payload.data,
      DOA: new Date(action.payload.data.DOA),
      DOS: new Date(action.payload.data.DOS),
      DOD: new Date(action.payload.data.DOD),
      DOR: new Date(action.payload.data.DOR),
    };
  }
  if (action.type === RESET_PATIENT_STATE) {
    return patientDetailsEdit;
  }
  return state;
};

const performaOneEdit = {
  chiefComplications: "",
  durationOfSymptoms: "",
  familyHistory: "",
  height: 0,
  weight: 0,
  BMI: 0.0,
  referingPhysician: "",
  previousRecordOfDrugTreatment: "",
  deformity: "",
  bonePain: "N",
  backache: "N",
  facialAsymmetry: "N",
  fracture: "",
  siteOfFracture: "",
  numberOfFracture: "",
  nonUnion: "",
  malunio: "",
  compressionFracture: "",
  blueSclera: "N",
  dentinogenesisImperfecta: "N",
  teethLoss: "N",
  deafness: "N",
  headache: "N",
  cafe_au_lait_macules: "N",
  difficultBite: "N",
  increaseSkullSize: "N",
  skinThickening: "N",
  tuftingOfPhalanges: "N",
};

const calcBMI = (height, weight) => {
  try {
    const heightInMeters = height / 100.0;
    const bmi = weight / (heightInMeters * heightInMeters);

    return Number.isFinite(bmi) ? parseFloat(bmi.toFixed(2)) : 0.0;
  } catch (error) {
    return 0.0;
  }
};


export const getPerformaOneReducer = (state = performaOneEdit, action) => {
  if (action.type === FORM_INPUT_CHANGE) {
    return {
      ...state,
      BMI: calcBMI(state.height, state.weight),
      [action.payload.name]: action.payload.value,
    };
  }
  if (action.type === GET_PERFORMAONE_SUCCESS) {
    return {
      ...state,
      ...action.payload.data,
    };
  }
  if (action.type === RESET_GET_PERFORMAONE_STATE) {
    return performaOneEdit;
  }
  return state;
};

const scansEdit = {
  boneScanNo: "",
  boneScanImpression: "",
  boneScanPdf: "",
  usgScanNo: "",
  usgScanImpression: "",
  usgScanPdf: "",
  petScanNo: "",
  petScanImpression: "",
  petScanPdf: "",
  mriScanNo: "",
  mriScanImpression: "",
  mriScanPdf: "",
  twodEchoScanNo: "",
  twodEchoScanImpression: "",
  twoEchoScanPdf: "",
  pathologyBiopsyNo: "",
  pathologyImpression: "",
  pathologyScanPdf: "",
  otherScanNo: "",
  otherScanImpression: "",
  otherScanPdf: "",
};

export const getScansReducer = (state = scansEdit, action) => {
  if (action.type === FORM_INPUT_CHANGE) {
    return {
      ...state,
      [action.payload.name]: action.payload.value,
    };
  }
  if (action.type === GET_SCANS_SUCCESS) {
    return {
      ...state,
      ...action.payload.data,
    };
  }
  if (action.type === GET_SCANS_SUCCESS) {
    return {
      ...state,
      ...action.payload.data,
    };
  }
  if (action.type === RESET_SCAN_STATE) {
    return scansEdit;
  }
  return state;
};

const HrpqctEdit = {
  armscan: "",
  legscan: "",
};

export const getHrpqctReducer = (state = HrpqctEdit, action) => {
  switch (action.type) {
    case FORM_INPUT_CHANGE:
      return {
        ...state,
        [action.payload.name]: action.payload.value,
      };
    case GET_HRPQCT_SUCCESS:
      return {
        ...state,
        ...action.payload.data,
      };
    default:
      return state;
  }
};

const xrayEdit = {
  pelvisPdf: "",
  lsPdf: "",
  skullPdf: "",
  wristPdf: "",
  chestPdf: "",
  anyotherPdf: "",
  armscan: "",
  legscan: "",
};

export const getXrayReducer = (state = xrayEdit, action) => {
  if (action.type === FORM_INPUT_CHANGE) {
    return {
      ...state,
      [action.payload.name]: action.payload.value,
    };
  }
  if (action.type === GET_XRAY_SUCCESS) {
    return {
      ...state,
      ...action.payload.data,
    };
  }
  if (action.type === RESET_XRAY_STATE) {
    return xrayEdit;
  }
  return state;
};

const disorderAndTreatmentEdit = {
  disorder: "0",
  treatment: "",
  remarks: "",
};

export const getDisorderAndTreatmentReducer = (
  state = disorderAndTreatmentEdit,
  action
) => {
  if (action.type === FORM_INPUT_CHANGE) {
    return {
      ...state,
      [action.payload.name]: action.payload.value,
    };
  }
  if (action.type === GET_DISORDER_ANS_TREATMENT_SUCCESS) {
    return {
      ...state,
      ...action.payload.data,
    };
  }
  if (action.type === RESET_DISORDER_ANS_TREATMENT_STATE) {
    return disorderAndTreatmentEdit;
  }
  return state;
};

const clinicalFeatureEdit = {
  formValues: [
    {
      operativeType: "0",
      painAbdomen: "",
      jointPain: "",
      galtAbnormality: "",
      visualImpairment: "",
      lossOfFacialSensation: "",
      precociousPuberty: "",
      proximalMuscleWeakness: "",
      endocrineAbnormalityPhpt: "",
      endocrineAbnormalityHyperthyroidism: "",
      endocrineAbnormalityTio: "",
      endocrineAbnormalityAcromegaly: "",
      endocrineAbnormalityAnyother: "",
      bonySwelling: "",
      anyOther: "",
    },
    {
      operativeType: "1",
      painAbdomen: "",
      jointPain: "",
      galtAbnormality: "",
      visualImpairment: "",
      lossOfFacialSensation: "",
      precociousPuberty: "",
      proximalMuscleWeakness: "",
      endocrineAbnormalityPhpt: "",
      endocrineAbnormalityHyperthyroidism: "",
      endocrineAbnormalityTio: "",
      endocrineAbnormalityAcromegaly: "",
      endocrineAbnormalityAnyother: "",
      bonySwelling: "",
      anyOther: "",
    },
    {
      operativeType: "2",
      painAbdomen: "",
      jointPain: "",
      galtAbnormality: "",
      visualImpairment: "",
      lossOfFacialSensation: "",
      precociousPuberty: "",
      proximalMuscleWeakness: "",
      endocrineAbnormalityPhpt: "",
      endocrineAbnormalityHyperthyroidism: "",
      endocrineAbnormalityTio: "",
      endocrineAbnormalityAcromegaly: "",
      endocrineAbnormalityAnyother: "",
      bonySwelling: "",
      anyOther: "",
    },
    {
      operativeType: "3",
      painAbdomen: "",
      jointPain: "",
      galtAbnormality: "",
      visualImpairment: "",
      lossOfFacialSensation: "",
      precociousPuberty: "",
      proximalMuscleWeakness: "",
      endocrineAbnormalityPhpt: "",
      endocrineAbnormalityHyperthyroidism: "",
      endocrineAbnormalityTio: "",
      endocrineAbnormalityAcromegaly: "",
      endocrineAbnormalityAnyother: "",
      bonySwelling: "",
      anyOther: "",
    },
    {
      operativeType: "4",
      painAbdomen: "",
      jointPain: "",
      galtAbnormality: "",
      visualImpairment: "",
      lossOfFacialSensation: "",
      precociousPuberty: "",
      proximalMuscleWeakness: "",
      endocrineAbnormalityPhpt: "",
      endocrineAbnormalityHyperthyroidism: "",
      endocrineAbnormalityTio: "",
      endocrineAbnormalityAcromegaly: "",
      endocrineAbnormalityAnyother: "",
      bonySwelling: "",
      anyOther: "",
    },
    {
      operativeType: "5",
      painAbdomen: "",
      jointPain: "",
      galtAbnormality: "",
      visualImpairment: "",
      lossOfFacialSensation: "",
      precociousPuberty: "",
      proximalMuscleWeakness: "",
      endocrineAbnormalityPhpt: "",
      endocrineAbnormalityHyperthyroidism: "",
      endocrineAbnormalityTio: "",
      endocrineAbnormalityAcromegaly: "",
      endocrineAbnormalityAnyother: "",
      bonySwelling: "",
      anyOther: "",
    },
  ],
};

export const getClinicalFeatureReducer = (
  state = clinicalFeatureEdit,
  action
) => {
  if (action.type === FORM_INPUT_CHANGE_MULTIPLE) {
    return {
      ...state,
      formValues: state.formValues.map((item, index) => {
        if (index !== action.payload.typeNumber) {
          return item;
        }
        return {
          ...item,
          [action.payload.name]: action.payload.value,
        };
      }),
    };
  }
  if (action.type === GET_CLINICAL_FEATURE_SUCCESS) {
    if (action.payload.data.formValues.length > 0)
      return {
        ...state,
        formValues: action.payload.data.formValues,
      };
    else return state;
  }
  if (action.type === RESET_CLINICAL_FEATURE_STATE) {
    return clinicalFeatureEdit;
  }
  return state;
};

const investigationEdit = {
  formValues: [
    {
      timePeriod: "0",
      hb: "",
      na: "",
      bloodUrea: "",
      sCreatinine: "",
      sUricAcid: "",
      sPhosphorus: "",
      sCalcium: "",
      albumin: "",
      sAlkalinePhosphate: "",
      sIPTH: "",
      ohVitD: "",
      urine: "",
      tmpGFR: "",
      TC_TG_LDL_HDL: "",
      sgot: "",
      sgpt: "",
      bilirubin: "",
      fgf_23: "",
      igf1: "",
      betaCrosslaps: "",
      p1np: "",
      t3: "",
      t4: "",
      tsh: "",
    },
    {
      timePeriod: "1",
      hb: "",
      na: "",
      bloodUrea: "",
      sCreatinine: "",
      sUricAcid: "",
      sPhosphorus: "",
      sCalcium: "",
      albumin: "",
      sAlkalinePhosphate: "",
      sIPTH: "",
      ohVitD: "",
      urine: "",
      tmpGFR: "",
      TC_TG_LDL_HDL: "",
      sgot: "",
      sgpt: "",
      bilirubin: "",
      fgf_23: "",
      igf1: "",
      betaCrosslaps: "",
      p1np: "",
      t3: "",
      t4: "",
      tsh: "",
    },
    {
      timePeriod: "2",
      hb: "",
      na: "",
      bloodUrea: "",
      sCreatinine: "",
      sUricAcid: "",
      sPhosphorus: "",
      sCalcium: "",
      albumin: "",
      sAlkalinePhosphate: "",
      sIPTH: "",
      ohVitD: "",
      urine: "",
      tmpGFR: "",
      TC_TG_LDL_HDL: "",
      sgot: "",
      sgpt: "",
      bilirubin: "",
      fgf_23: "",
      igf1: "",
      betaCrosslaps: "",
      p1np: "",
      t3: "",
      t4: "",
      tsh: "",
    },
    {
      timePeriod: "3",
      hb: "",
      na: "",
      bloodUrea: "",
      sCreatinine: "",
      sUricAcid: "",
      sPhosphorus: "",
      sCalcium: "",
      albumin: "",
      sAlkalinePhosphate: "",
      sIPTH: "",
      ohVitD: "",
      urine: "",
      tmpGFR: "",
      TC_TG_LDL_HDL: "",
      sgot: "",
      sgpt: "",
      bilirubin: "",
      fgf_23: "",
      igf1: "",
      betaCrosslaps: "",
      p1np: "",
      t3: "",
      t4: "",
      tsh: "",
    },
    {
      timePeriod: "4",
      hb: "",
      na: "",
      bloodUrea: "",
      sCreatinine: "",
      sUricAcid: "",
      sPhosphorus: "",
      sCalcium: "",
      albumin: "",
      sAlkalinePhosphate: "",
      sIPTH: "",
      ohVitD: "",
      urine: "",
      tmpGFR: "",
      TC_TG_LDL_HDL: "",
      sgot: "",
      sgpt: "",
      bilirubin: "",
      fgf_23: "",
      igf1: "",
      betaCrosslaps: "",
      p1np: "",
      t3: "",
      t4: "",
      tsh: "",
    },
    {
      timePeriod: "5",
      hb: "",
      na: "",
      bloodUrea: "",
      sCreatinine: "",
      sUricAcid: "",
      sPhosphorus: "",
      sCalcium: "",
      albumin: "",
      sAlkalinePhosphate: "",
      sIPTH: "",
      ohVitD: "",
      urine: "",
      tmpGFR: "",
      TC_TG_LDL_HDL: "",
      sgot: "",
      sgpt: "",
      bilirubin: "",
      fgf_23: "",
      igf1: "",
      betaCrosslaps: "",
      p1np: "",
      t3: "",
      t4: "",
      tsh: "",
    },
  ],
};

export const investigationReducer = (state = investigationEdit, action) => {
  if (action.type === FORM_INPUT_CHANGE_MULTIPLE) {
    return {
      ...state,
      formValues: state.formValues.map((item, index) => {
        if (index !== action.payload.typeNumber) {
          return item;
        }
        return {
          ...item,
          [action.payload.name]: action.payload.value,
        };
      }),
    };
  }
  if (action.type === GET_INVESTIGATION_SUCCESS) {
    if (action.payload.data.formValues.length > 0)
      return {
        ...state,
        formValues: action.payload.data.formValues,
      };
    else return state;
  }
  if (action.type === RESET_INVESTIGATION_STATE) {
    return investigationEdit;
  }
  return state;
};

const dexaEdit = {
  formValues: [
    {
      region: "0",
      lumberSpine: "",
      leftHip: "",
      rightHip: "",
      neck: "",
      radius_ulna: "",
    },
    {
      region: "1",
      lumberSpine: "",
      leftHip: "",
      rightHip: "",
      neck: "",
      radius_ulna: "",
    },
    {
      region: "2",
      lumberSpine: "",
      leftHip: "",
      rightHip: "",
      neck: "",
      radius_ulna: "",
    },
    {
      region: "3",
      lumberSpine: "",
      leftHip: "",
      rightHip: "",
      neck: "",
      radius_ulna: "",
    },
  ],
};

export const dexaReducer = (state = dexaEdit, action) => {
  if (action.type === FORM_INPUT_CHANGE_MULTIPLE) {
    return {
      ...state,
      formValues: state.formValues.map((item, index) => {
        if (index !== action.payload.typeNumber) {
          return item;
        }
        return {
          ...item,
          [action.payload.name]: action.payload.value,
        };
      }),
    };
  }
  if (action.type === GET_DEXA_SUCCESS) {
    if (action.payload.data.formValues.length > 0)
      return {
        ...state,
        formValues: action.payload.data.formValues,
      };
    else return state;
  }
  if (action.type === RESET_DEXA_STATE) {
    return dexaEdit;
  }
  return state;
};

const dexa1Edit = {
  formValues: [
    {
      region1: "0",
      lumberSpine1: "",
      leftHip1: "",
      rightHip1: "",
      neck1: "",
      radius_ulna1: "",
    },
    {
      region1: "1",
      lumberSpine1: "",
      leftHip1: "",
      rightHip1: "",
      neck1: "",
      radius_ulna1: "",
    },
    {
      region1: "2",
      lumberSpine1: "",
      leftHip1: "",
      rightHip1: "",
      neck1: "",
      radius_ulna1: "",
    },
    {
      region1: "3",
      lumberSpine1: "",
      leftHip1: "",
      rightHip1: "",
      neck1: "",
      radius_ulna1: "",
    },
  ],
};

export const dexa1Reducer = (state = dexa1Edit, action) => {
  if (action.type === FORM_INPUT_CHANGE_MULTIPLE) {
    return {
      ...state,
      formValues: state.formValues.map((item, index) => {
        if (index !== action.payload.typeNumber) {
          return item;
        }
        return {
          ...item,
          [action.payload.name]: action.payload.value,
        };
      }),
    };
  }
  if (action.type === GET_DEXA1_SUCCESS) {
    if (action.payload.data.formValues.length > 0)
      return {
        ...state,
        formValues: action.payload.data.formValues,
      };
    else return state;
  }
  if (action.type === RESET_DEXA1_STATE) {
    return dexa1Edit;
  }
  return state;
};

const dexa3Edit = {
  formValues: [
    {
      region3: "0",
      lumberSpine3: "",
      leftHip3: "",
      rightHip3: "",
      neck3: "",
      radius_ulna3: "",
    },
    {
      region3: "1",
      lumberSpine3: "",
      leftHip3: "",
      rightHip3: "",
      neck3: "",
      radius_ulna3: "",
    },
    {
      region3: "2",
      lumberSpine3: "",
      leftHip3: "",
      rightHip3: "",
      neck3: "",
      radius_ulna3: "",
    },
    {
      region3: "3",
      lumberSpine3: "",
      leftHip3: "",
      rightHip3: "",
      neck3: "",
      radius_ulna3: "",
    },
  ],
};

export const dexa3Reducer = (state = dexa3Edit, action) => {
  if (action.type === FORM_INPUT_CHANGE_MULTIPLE) {
    return {
      ...state,
      formValues: state.formValues.map((item, index) => {
        if (index !== action.payload.typeNumber) {
          return item;
        }
        return {
          ...item,
          [action.payload.name]: action.payload.value,
        };
      }),
    };
  }
  if (action.type === GET_DEXA3_SUCCESS) {
    if (action.payload.data.formValues.length > 0)
      return {
        ...state,
        formValues: action.payload.data.formValues,
      };
    else return state;
  }
  if (action.type === RESET_DEXA3_STATE) {
    return dexa3Edit;
  }
  return state;
};

const patientsInitialState = {
  patients: [],
};

export const patientsReducer = (state = patientsInitialState, action) => {
  if (action.type === GET_PATIENTS_SUCCESS) {
    return {
      patients: action.payload.patients,
    };
  }

  return state;
};
